/* This is generated code, don't alter */
var IfcRecurrenceTypeEnum;
(function (IfcRecurrenceTypeEnum) {
    IfcRecurrenceTypeEnum[IfcRecurrenceTypeEnum["DAILY"] = 0] = "DAILY";
    IfcRecurrenceTypeEnum[IfcRecurrenceTypeEnum["WEEKLY"] = 1] = "WEEKLY";
    IfcRecurrenceTypeEnum[IfcRecurrenceTypeEnum["MONTHLY_BY_DAY_OF_MONTH"] = 2] = "MONTHLY_BY_DAY_OF_MONTH";
    IfcRecurrenceTypeEnum[IfcRecurrenceTypeEnum["MONTHLY_BY_POSITION"] = 3] = "MONTHLY_BY_POSITION";
    IfcRecurrenceTypeEnum[IfcRecurrenceTypeEnum["BY_DAY_COUNT"] = 4] = "BY_DAY_COUNT";
    IfcRecurrenceTypeEnum[IfcRecurrenceTypeEnum["BY_WEEKDAY_COUNT"] = 5] = "BY_WEEKDAY_COUNT";
    IfcRecurrenceTypeEnum[IfcRecurrenceTypeEnum["YEARLY_BY_DAY_OF_MONTH"] = 6] = "YEARLY_BY_DAY_OF_MONTH";
    IfcRecurrenceTypeEnum[IfcRecurrenceTypeEnum["YEARLY_BY_POSITION"] = 7] = "YEARLY_BY_POSITION";
})(IfcRecurrenceTypeEnum || (IfcRecurrenceTypeEnum = {}));
const IfcRecurrenceTypeEnumCount = 8;
export { IfcRecurrenceTypeEnum, IfcRecurrenceTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcRecurrenceTypeEnum = new Int32Array([4, 1, 15]);
let prefixSumAddressIfcRecurrenceTypeEnum = new Uint32Array([0, 24, 49, 57, 75, 96, 116, 123, 137]);
let slotMapIfcRecurrenceTypeEnum = new Int32Array([6, 2, 1, 5, 3, 7, 0, 4]);
let encodedDataIfcRecurrenceTypeEnum = (new TextEncoder()).encode(".YEARLY_BY_DAY_OF_MONTH..MONTHLY_BY_DAY_OF_MONTH..WEEKLY..BY_WEEKDAY_COUNT..MONTHLY_BY_POSITION..YEARLY_BY_POSITION..DAILY..BY_DAY_COUNT.");
let IfcRecurrenceTypeEnumSearch = new MinimalPerfectHash(gMapIfcRecurrenceTypeEnum, prefixSumAddressIfcRecurrenceTypeEnum, slotMapIfcRecurrenceTypeEnum, encodedDataIfcRecurrenceTypeEnum);
export { IfcRecurrenceTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcRecurrenceTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcRecurrenceTypeEnumSearch, input, cursor, endCursor);
}
